import Speech from './Speech';

export default Speech;
